import './button.css'
import { animateScroll as scroll } from "react-scroll";
import Cv from '../assets/certificate/Syed Usama Ali.pdf'
 const Button =()=>{
    return(
        <div className="center">
        <div className="outer button">
        <button  onClick={() => scroll.scrollToBottom()}>
Contact Me
</button>
        
        
        <span></span>
        <span></span>
      </div>
      <div className="outer button">
        <a href={Cv} target="_blank" rel="noopener noreferrer" download>
        <button >Download Resume</button>
        </a>
    
        
        <span></span>
        <span></span>
      </div>
      </div>


    )
}
export default Button